module.exports = __webpack_public_path__ + "static/a-xx-152-art-ba52d3466d64e43e3390c43d95d2bffd.jpg";